/* istanbul ignore file */
import { Role } from '.';
import { SmartsForm } from '../services/logic-services/models';

export class Project {
    active?: boolean;
    consumesFromProjectIds?: string[];
    projectNotes?: { [projectId: string]: string[]; }[];
    createdBy?: string;
    dateCreated?: string;
    defaultRole?: string;
    description?: string;
    id?: string;
    isProjectAdmin?: boolean;
    JSONForms?: SmartsForm;
    layoutDraft?: SmartsForm;
    name?: string;
    order?: number;
    projectId?: string;
    roleId?: Role | string;
    roles?: Role[];
    isSaving?: boolean;
    documentVersion?: number;
    isSummaryProject?: boolean = false;
}
